// extracted by mini-css-extract-plugin
export default {"root":"GNXC0","button":"cMzyx","active":"pLAI_","text":"Lp0vv"};